/**
 * DO NOT MANUALLY CHANGE THIS FILE AS IT IS AUTOGENERATED.
 */
import { Icon } from '@atlaskit/icon/base';
import { type GlyphProps } from '@atlaskit/icon/types';
import React from 'react';

function HomeIconGlyph() {
  return (
    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        d="m12.44 3.102.115.066 9 6a1 1 0 0 1-1.009 1.723l-.1-.059-.446-.297V18a2 2 0 0 1-1.85 1.994L18 20h-3a2 2 0 0 1-1.995-1.85L13 18v-4h-2v4a2 2 0 0 1-1.85 1.994L9 20H6a2 2 0 0 1-1.995-1.85L4 18v-7.465l-.445.297a1 1 0 0 1-1.317-.184l-.07-.093a1 1 0 0 1 .184-1.317l.093-.07 9-6a1 1 0 0 1 .994-.066Zm-.44 2.1-6 4V18h3v-4a2 2 0 0 1 1.85-1.995L11 12h2a2 2 0 0 1 1.995 1.85L15 14v4h3V9.202l-6-4Z"
        fill="currentColor"
      />
    </svg>
  );
}

function HomeIcon(props: GlyphProps) {
  return <Icon glyph={HomeIconGlyph} {...props} />;
}

export default HomeIcon;
